module.exports = __webpack_public_path__ + "assets/maison-campagne.460a4f47.svg";